// extracted by mini-css-extract-plugin
module.exports = {"label":"MultipleChoice_label__6YLLp","selectedOptionsWrapper":"MultipleChoice_selectedOptionsWrapper__203cc","chip":"MultipleChoice_chip__1Cv_w"};